export default function retry(failureCount, error) {
  // It's not clear to me how error (or error.response) can be
  // undefined, but we've seen it in production, so cue the paranoia.
  if ( error?.response?.status === 404 ) {
    return false
  }

  return ( failureCount < 1 )
}
